import axiosInstance from "@/utils/axiosInstance";

const baseUrl = `api/bookings`;

const state = {};

const getters = {};

const mutations = {};

const actions = {
  create({commit}, payload: { booking: object }) {
    return axiosInstance.post(baseUrl, {booking: payload.booking}).then((data) => data.data);
  },
  read({commit}, payload: {
    companyId: string,
    startDate: string,
    endDate: string,
    userIds: number[],
    keyIds: number[],
  }) {
    return axiosInstance.get(baseUrl, {
      params: {
        companyId: payload.companyId,
        startDate: payload.startDate,
        endDate: payload.endDate,
        userIds: payload.userIds,
        keyIds: payload.keyIds,
      },
    }).then((data) => data.data);
  },
  update({commit}, payload: { id: number, booking: object, alertCreator: boolean }) {
    return axiosInstance.put(`${baseUrl}/${payload.id}`, {
      booking: payload.booking,
      alertCreator: payload.alertCreator,
    }).then((data) => data.data);
  },
  delete({commit}, payload: { id: number}) {
    return axiosInstance.delete(`${baseUrl}/${payload.id}`).then((data) => data.data);
  },
  getKeysForBooking({commit}, payload: {
    // Filters
    companyId: number,
    startDate?: Date,
    endDate?: Date,
    onlyAvailableKeys?: boolean
    excludeIds?: number[]
    // Pagination
    page: number,
    itemsPerPage: number,
    search: string | null,
  }) {
    return axiosInstance.get(`${baseUrl}/keys`, {params: payload})
      .then((data) => data.data);
  },
  conflict({commit}, payload: { booking: object }) {
    return axiosInstance.post(`${baseUrl}/conflict`, {booking: payload.booking}).then((data) => data.data);
  },
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
};
